import { Button, Form, Modal } from "antd";
import React, { useState } from "react";
import { CustomerOtpVerify } from "../../ApiService/Apis/Auth/Auth";
import { colors, Makelabel } from "../../Utils/Index";
import OTPInput from "react-otp-input";

const OtpModal = ({ open, otpData, setOpen, callbackApi = () => { } }) => {
  const [btnLoading, setBtnLoading] = useState(false);

  const handleFinish = (val) => {
    setBtnLoading(true);
    let temp = { ...val };
    temp["mobile_number"] = otpData?.mobileNumber;
    temp["otp"] = Number(val.otp);
    temp["verificationToken"] = otpData?.verificationToken;
    CustomerOtpVerify(temp)
      .then((res) => {
        if (res.status) {
          callbackApi(res.data);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };
  return (
    <Modal
      className="confirm-modal"
      closable={false}
      footer={null}
      open={open}
      onCancel={() => setOpen(false)}
      onClose={() => setOpen(false)}
    >
      <Form onFinish={(val) => handleFinish(val)}>
        <Form.Item
          name={"otp"}
          rules={[
            {
              required: true,
              message: "Authentication Code Is Required",
            },
          ]}
          labelCol={{ span: 24 }}
          label={Makelabel("Verify Otp")}
        >
          <OTPInput
            //   value={otp}
            //   onChange={setOtp}
            numInputs={6}
            renderInput={(props) => (
              <input
                {...props}
                type="tel" // This triggers the numeric keypad on mobile
                inputMode="numeric" // Ensures numeric keypad on modern browsers
                pattern="[0-9]*" // Optional: only allow digits
              />
            )}

            inputStyle={{
              width: "80%",
              marginRight: "10px",
              height: "40px",
              border: "2px solid var(--bgdark2)",
            }}
          />
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            loading={btnLoading}
            style={{ background: colors.green }}
            iconPosition="end"
            htmlType="submit"
            className=" rounded-none bg-brand w-full mt-4  text-dynmaicText font-bold font-inter bg-secondary"
          >
            Verify Otp
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default OtpModal;
